import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, userApiClient } from '@/setup/api'

export type IBlogTopicsResponseData = ApiResponseBody<'get', '/web/blog/content/topics'>['data']

export const getAllBlogTopicsQueryOptions = (locale: string) =>
    userApiClient.queryOptions('get', '/web/blog/content/topics', {
        headers: { 'accept-language': locale },
    })

export function useGetAllBlogTopicsQuery() {
    const locale = useLocale()

    return useQuery(getAllBlogTopicsQueryOptions(locale))
}
